import React from 'react';
import styles from "./Chip.module.css";
import clsx from "clsx"
interface IChipProps {
    id: number,
    text: string,
    count: number,
    isSeleted: boolean,
    onClick: () => void
}
const Chip = (props: IChipProps) => {
    return (
        <div className={clsx(styles.item, props.isSeleted ? styles.selected : "")}
            onClick={props.onClick}
        >
            {props.text}
            {props.count > 0 &&
                <span className={styles.count}>
                    {props.count}
                </span>
            }
        </div>
    );
};

export default Chip;